// Generated by BUCKLESCRIPT VERSION 2.2.2, PLEASE EDIT WITH CARE
'use strict';

var App = require("./app");
var Game = require("./game");
var ReactDOMRe = require("reason-react/lib/js/src/ReactDOMRe.js");
var ReasonReact = require("reason-react/lib/js/src/ReasonReact.js");

((require('./index.css')));

var game = Game.init(/* array */[
      /* record */[
        /* name */"White Player",
        /* color : White */0
      ],
      /* record */[
        /* name */"Black Player",
        /* color : Black */1
      ]
    ]);

ReactDOMRe.renderToElementWithId(ReasonReact.element(/* None */0, /* None */0, App.make(game, /* array */[])), "root");

exports.game = game;
/*  Not a pure module */



//////////////////
// WEBPACK FOOTER
// ./src/index.re
// module id = 28
// module chunks = 0